<script lang="ts">
    import { _ } from "svelte-i18n"
</script>

<div class="subline">{$_("checkout.order")}</div>
<h2 class="h2_nooffset">{$_("checkout.thank-you-for-order")}</h2>

<section>
    <p>
        {@html $_("checkout.order-comfirmation-html")}
    </p>
</section>
